<template>
	<div class="cont_box">
		<div class="gall_box bai_box">
			<div class="gall_mbx">
				<el-breadcrumb separator=">">
					<el-breadcrumb-item>当前位置</el-breadcrumb-item>
					<el-breadcrumb-item>数据集</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="gall_gg">
				<div class="gall_gg_box">
					<!-- <div class="gall_gg_tit">
						{{coopData.noticeTitle}}
					</div> -->
					<div><span>   敬请期待！</span></div>
					<!-- <div class="gall_gg_p" v-html="coopData.noticeContent">
					</div> -->
				</div>
				<!-- <div class="gall_gg_btn" @click="up_btn">
					我要上传
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import headers from '@/components/header';
	import foot from '@/components/foot';
	export default {
		name: "UserDialong",
		data() {
			return {
				not_flag: true,
				tab_index: 'tltw',
				currentPage3: 5,
				coopData: '',
			}
		},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				this.$http.get('/front/notice/cooperation').then(res => {
					
					let data =res.data
					this.coopData = data
				})
			},
			up_btn() {
				this.$router.push({
					path: 'chart_up'
				})
			},
			stor_btn() {
				this.$router.push({
					path: 'story_dec'
				})
			},
			slt_btn() {
				this.$router.push({
					path: 'gallery_indexTw'
				})
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			}
		},
		components: {
			headers,
			foot,
		}
	}
</script>

<style lang="less" scoped>
	
	.scan_code {
		float: right;
		width: 88px;
		text-align: center;
		margin: 19px 0 0 26px;
		position: relative;

		.wx_qr_code {
			width: 88px;
			height: 88px;
		}

		h5 {
			text-decoration: none;
			font-weight: normal;
			line-height: 1.4;
			font-size: 12px;
			position: absolute;
			left: 0;
			top: 90px;
			width: 88px;

		}
	}

	.gall_gg {
		margin-bottom: 71px;
		padding: 0 31px 50px;
		
		.gall_gg_box{
			//width: 808px;
			width: 1138px;
			height: 445px;
			background: url(../../assets/image/pic_hptc_bg@2x.png) no-repeat;
			background-size: 100% 100%;
			background-position: center;
			padding: 0 134px;
			box-sizing: border-box;
			padding-top: 32px;
			.gall_gg_tit {
				font-size: 23px;
				color: #333333;
				font-weight: bold;
				text-align: center;
				margin-bottom: 32px;
			}
			.gall_gg_p{
				color: #4A4A4A;
				max-height: 280px;
				overflow-y: auto;
				line-height: normal;
			}
		}
		.gall_gg_btn{
			margin: 45px auto 0;
			height: 60px;
			text-align: center;
			line-height: 60px;
			border-radius: 30px;
			background-color: #22AB67;
			color: #fff;
			font-size: 18px;
			width: 375px;
			cursor: pointer;
		}
	}

	.gall_box {
		//width: 870px;
		width: 1200px;
		margin: 0 auto;

		.gall_mbx {
			margin: 0 0 58px;
			padding: 37px 23px 0;

			span {
				font-size: 13px;
			}
		}
	}
</style>
